<template>
  <div>
      <div class="p1" :style="topbg">
          <div class="pcenterbg">
              <div class="pgt1">{{title}}</div>
              <div class="pgt2">{{des}}</div>
              <div><span class="pgbt">了解更多</span></div>
          </div>
      </div>
      <div class="s2">
          <div class="s2_m1" v-html="content">
            <!-- <img src="../../static/plan/chinaun.png" class="s2p" alt="">
            <div class="s2_m1_c">中国联合网络通信集团有限公司（英文名称China Unicom、简称“中国联通”、“联通”）于2009年1月6日在原中国网通和原中国联通的基础上合并组建而成，在国内31个省（自治区、直辖市）和境外多个国家和地区设有分支机构，是中国唯一一家在纽约、香港、上海三地同时上市的电信运营企业，连续多年入选“世界500强企业”。</div>
            <div class="s2_m1_t">客户介绍</div>
            <div class="s2_m1_c">中国联通主要经营GSM、WCDMA和FDD-LTE制式移动网络业务，固定通信业务，国内、国际通信设施服务业务，卫星国际专线业务、数据通信业务、网络接入业务和各类电信增值业务，与通信信息业务相关的系统集成业务等。2009年1月6日，原中国联合通信有限公司与原中国网络通信集团公司重组合并，新公司更名为中国联合网络通信集团有限公司。为与合并前的中国联通相区分，业界常以“新联通”进行称呼。
中国联通拥有覆盖全国、通达世界的通信网络，积极推进固定网络和移动网络的宽带化，为广大用户提供全方位、高品质信息通信服务。2009年1月，中国联通获得了当今世界上技术最为成熟、应用最为广泛、产业链最为完善的WCDMA制式的3G牌照，拥有“沃3G/沃4G”、“沃派”、“沃家庭”等著名客户品牌。
2018年2月11日，中国联通发布关于限制性股票激励计划（草案修订稿）及首期授予方案（草案修订稿）等一系列相关公告。首期拟向激励对象授予不超过84788万股的限制性股票，约占当前公司股本总额的2.8%</div>
            <div class="s2_m1_t">项目背景及客户需求</div>
            <div class="s2_m1_c">中国联通主要经营GSM、WCDMA和FDD-LTE制式移动网络业务，固定通信业务，国内、国际通信设施服务业务，卫星国际专线业务、数据通信业务、网络接入业务和各类电信增值业务，与通信信息业务相关的系统集成业务等。2009年1月6日，原中国联合通信有限公司与原中国网络通信集团公司重组合并.</div> -->
          </div>
      </div>
    <us></us>
  </div>
</template>

<script>
import us from '@/components/us'
import solution from '@/components/solution'
import { apiUrl, baseUrl } from '@/config/config'
const axios = require('axios');
export default {
  components: {us,solution},
  data(){
        return {
            content: null,
            id: null,
            title:null,
            des:null,
            topbg: {
                'background-image': "url("+baseUrl+"/img/scienceinfo_top.png)"
            }
        }
    },
    created: function (){
        this.id = this.$route.query.id;
        this.getInfo();
    },
    watch: {
        $route: {
            handler() {
                this.id = this.$route.query.id;
                this.getInfo();
            },
            deep: true,
        }
    },  
    methods:{
        getInfo(){
            axios.get(apiUrl+'/product/findById?id='+this.id).then(res=>{
              console.log(res.data.data)
                this.content = res.data.data.content;
                this.title = res.data.data.title;
                this.des = res.data.data.des;
            })
        },
    }
}
</script>

<style scoped>
.p1{
  width: 750px;
  height: 440px;
  background-repeat:no-repeat;
  background-position:center center;
  background-size: cover;
  display: flex;
  align-items: center;
}
.s2{
    width: 750px;
    background: #F5F5F7;
    box-sizing: border-box;
    padding: 42px 28px;
}
.s2_m1{
    width: 694px;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 30px 20px;
    font-size: 28px;
    font-weight: 400;
    color: #666666;
    line-height: 60px;
}
.s2_m1_c{
    margin-top: 24px;
}
.s2p{
    width: 200px;
    height: 106px;
    margin-left: 248px;
}
.s2_m1_t{
    font-size: 28px;
    font-weight: 500;
    color: #222222;
    margin-top: 30px;
}
.s2_m1 >>> img{
    width: 656px !important;
    height: auto !important;
}
</style>